import { GetProfileQuery } from 'generated/graphql';
import {
  CustomColorSchema,
  Gender,
  MediaObject,
  ProfileDomain,
  ProfileMode,
  genders,
} from './Profile.types';

type ServerCreator = NonNullable<GetProfileQuery['creator']>;
type ServerMedia = NonNullable<ServerCreator['mediaAvatar']>;

const DEFAULT_COLOR = '000000';

const toMediaObject = (
  raw: ServerMedia | null | undefined,
): MediaObject | null => {
  if (!raw) return null;

  return {
    source: raw.source ?? null,
    cdn01: raw.cdn01 ?? '',
    image: raw.image ?? null,
    video: raw.video ?? null,
    audio: raw.audio ?? null,
    width: raw.width ?? null,
    height: raw.height ?? null,
    mimeType: raw.mimeType ?? null,
  };
};

const toGender = (raw: string | null | undefined): Gender | null => {
  if (!raw) return null;
  return genders.includes(raw as Gender) ? (raw as Gender) : null;
};

const toProfileMode = (raw: number | null | undefined): ProfileMode => {
  if (raw === 4) return 'Live';
  if (raw === 5) return 'RunOff';
  return 'NotLive';
};

const toColorSchema = (
  raw: ServerCreator['customColorSchema'],
): CustomColorSchema => ({
  primaryColor: raw?.primaryColor || DEFAULT_COLOR,
});

const toKeywords = (raw: Array<string | null> | null | undefined): string[] => {
  if (!raw) return [];
  return raw.filter((k): k is string => k !== null);
};

export const toProfileDomain = (raw: ServerCreator): ProfileDomain => ({
  id: raw.id,
  firstName: raw.firstName ?? '',
  lastName: raw.lastName ?? '',
  customURL: raw.customURL ?? '',
  mode: toProfileMode(raw.mode),
  title: raw.title ?? '',
  gender: toGender(raw.gender),
  messageProfile: raw.messageProfile ?? '',
  keywords: toKeywords(raw.keywords),
  accomplishments: raw.accomplishments ?? '',
  profileInstagram: raw.profileInstagram ?? '',
  profileTiktok: raw.profileTiktok ?? '',
  profileYoutubeChannel: raw.profileYoutubeChannel ?? '',
  mediaAvatar: toMediaObject(raw.mediaAvatar),
  mediaCover: toMediaObject(raw.mediaCover),
  mediaWelcome: toMediaObject(raw.mediaWelcome),
  mediaBanner: toMediaObject(raw.mediaBanner),
  customColorSchema: toColorSchema(raw.customColorSchema),
});
